import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PermissionsEnum } from '../../../api/api-reference';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-monitoring-menu',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterOutlet],
  templateUrl: './monitoring-menu.component.html',
  styleUrl: './monitoring-menu.component.scss',
})
export class MonitoringMenuComponent {
  PermissionEnum= PermissionsEnum;
  constructor(private router: Router, public authService: AuthService) {}

  isActive(tab: string) {
    const currentRoute = this.router.url;
    if (currentRoute.includes(tab)) return true;
    else return false;
  }
  navigate(route: string) {
    this.router.navigate([route]);
  }
}
